module.exports = __webpack_public_path__ + "static/img/home_bg_all.18b478f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/home_bg_all.png
// module id = 3GzW
// module chunks = 8